var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"classic-view\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"page-header\"><a ui-sref=\"root.dashboard.quick_form\" class=\"btn btn-success pull-right\"><i class=\"fa fa-plus-circle\"></i> Create New Application Form</a><h1 class=\"pull-left\"><span>Current Active Application Forms</span></h1></div></div></div><div class=\"row\"><div class=\"col-md-12\"><quick-forms-display></quick-forms-display></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/quick_forms/quick_forms_display.jade
// module id = 984
// module chunks = 0